module.exports = __webpack_public_path__ + "img/cintura.7b545054.png";